import { useContext } from "react";
import SimulationContext from "../contexts/Simulation";

const ResultStep = () => {
  const [simParams] = useContext(SimulationContext);
  const numberFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
  const numberDecimalFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

  return (
    <div className={'content results ' + (!simParams.infos?.daily_presence ? 'batt' : '')}>
      <h3>AVEC NOUS, VOICI CE QUE LE SOLEIL<br/>peut FAIRE POUR VOUS.</h3>
      <div className="kpis">
        <div className="peak_power">
          <div className="txt">Puissance recommandée pour votre maison</div>
          <div className="kpi">{ simParams.simResults?.peak_power } kWc</div>
        </div>
        <div className="cost">
          <div className="txt">Budget pour l'installation (pose par nos propres équipes)</div>
          <div className="kpi">{ numberFormatter.format(simParams.simResults?.system_cost) } <sub>TTC</sub><sup>€*</sup></div>
          { !simParams.infos?.daily_presence && 
          <div className="battery">
            <span>+</span>
            <div className="pill">Batterie</div>
            <div className="option">En option</div>
          </div>
          }
        </div>
        <div className="savings">
          <div className="txt">Économies estimées sur { simParams.simResults?.depreciation_period } ans</div>
          <div className="kpi">{ numberFormatter.format(simParams.simResults?.total_savings) } <sub>TTC</sub><sup>€</sup></div>
        </div>
      </div>
      <div className="roi">
        <div className="roival">
          <div className="kpi">{ numberDecimalFormatter.format(simParams.simResults?.yearly_roi * 100) }%</div>
          <div className="txt">de rendement en moyenne sur { simParams.simResults?.depreciation_period } ans</div>
        </div>
        <div className="figures">
          <div className="title">Un rendement qui fait rayonner vos finances **</div>
          Bien au-delà d'un Livret A <strong>(~3 %)</strong>,<br/>
          d'une obligation d'État <strong>(~3 %)</strong><br/>
          ou même d'un investissement immobilier <strong>(~5 %)</strong>.
        </div>
      </div>
      <div className="sub">* Estimations basées sur une maison de plain-pied aux normes RT2012, avec toit bac acier, pente &lt;10°, onduleur centralisé.<br/>
      ** Moyenne constatée chez nos clients.</div>
      <div className="ctas">
        <div className="button yellow">Ça m'intéresse</div>
      </div>
    </div>
  )
}

export default ResultStep;